import DatePicker from "../../components/DatePicker";
import { useForm, useWatch } from "react-hook-form";
import ShowAlert from "../../utility/Alert";
import axios from "axios";
import "../WelcomeScreen.css"
import "./productSearch.css"
import * as XLSX from "xlsx";
import { FaPhoneAlt } from "react-icons/fa";

import "react-toastify/dist/ReactToastify.css"; // Import styles
import { FaDownload } from "react-icons/fa6";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";

import { useState, useEffect, useRef } from "react";
import SelectInput from "../../components/SelectInput";
import { api_url } from "../../apiconfig/authService";
import LoadingOverlay from "../../components/LoadingCompont/Loading";

const currentDate = new Date();
currentDate.setHours(0, 0, 0, 0);

function formatDuration(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const milliseconds = ms % 1000;
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return [
        hours.toString().padStart(2, '0'),
        minutes.toString().padStart(2, '0'),
        seconds.toString().padStart(2, '0')
    ].join(':') + '.' + milliseconds.toString().padStart(3, '0');
}

const SessionInfo = () => {
    const [loading, setLoading] = useState(false);
    const [excelLoading, setExcelLoading] = useState(false);
    const [startDate, setStartDate] = useState(currentDate)
    const [lastDate, setLastDate] = useState(currentDate)
    const [userInfoList, setUserInfoList] = useState([])
    const [sessionByUserList, setSessionByUserList] = useState([])
    const [selectedUserSessions, setSelectedUserSessions] = useState(null)
    const [showPhoneNolist, setShowPhoneNoList] = useState(false)
    const [showSessionlist, setSessionList] = useState(false)
    const dropdownRef = useRef(null);
    const sessionRef = useRef(null)
    const [selectedPhoneNo, setSelectedPhoneNo] = useState(null);
    const [selectedSessionNo, setSelectedSessionNo] = useState(null);
    const [actualData, setActualData] = useState(null)
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm();


    const userType = useWatch({
        control,
        name: "userType",
    });




    useEffect(() => {
        const fetchData = async () => {
            setSelectedPhoneNo(null)
            setSelectedSessionNo(null)
            setLoading(true);
            try {
                if (userType) {
                    const res = await axios.get(`${api_url}/utm/session-userInfo?startDate=${startDate}&endDate=${lastDate}&userType=${userType}`)

                    if (userType === "User") {
                        setActualData(res?.data?.data)

                        setUserInfoList(res?.data?.data?.users)
                        setSessionByUserList(res?.data?.data?.sessionsByUser)
                    }
                    else if (userType === "Guest") {
                        setActualData(res?.data?.data)
                        setSessionByUserList(res?.data?.data?.sessions)
                    }
                    else {
                        setActualData(res?.data?.data)
                    }
                }
            }
            catch (e) {
                console.log(e.response.data.message)
                ShowAlert("error", e.response?.data?.message)
            } finally {
                setLoading(false); // Stop loading regardless of success/error
            }
        }
        fetchData()
    }, [userType, startDate, lastDate]);

    const handleSelect = (curr) => {
        console.log("inside", curr)
        setSelectedPhoneNo(curr.customerphone);
        setSelectedSessionNo(null)
        setSelectedUserSessions(sessionByUserList[curr._id]?.sessions)
        setShowPhoneNoList(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowPhoneNoList(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sessionRef.current && !sessionRef.current.contains(event.target)) {
                setSessionList(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const handleExcel = async () => {

        console.log("userType", userType)

        if (userType === "User" && selectedPhoneNo) {

            if (!selectedUserSessions.length > 0) {
                return
            }

            console.log("seleData", selectedUserSessions)
            try {
                const excelData = selectedUserSessions.map((search, index) => ({
                    userid: search.userId._id,
                    UserName: search.userId.name || "",
                    emailId: search?.emailid || "",
                    devicetype: search?.deviceInfo?.deviceType || "",
                    deviceid: search?.deviceInfo?.deviceId,
                    logintype: search?.loginType || "",
                    locationtype: search?.locationType || "",
                    location: search?.location || " ",
                    pincode: search?.pincode || "",
                    sessionid: search?.sessionId || "",
                    sessionTime: new Date(search?.createdAt).toLocaleDateString(),
                    Using_Duration: formatDuration(search.durationInSeconds) || "00:00:00",
                }));

                // Create workbook and worksheet
                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(excelData);

                // Add worksheet to workbook
                XLSX.utils.book_append_sheet(wb, ws, "Session Data");

                // Generate file name with session ID and current date
                const fileName = `SessionList_${selectedPhoneNo}_Data_${new Date().toISOString().split('T')[0]}.xlsx`;

                // Download the file
                XLSX.writeFile(wb, fileName);

            } catch (error) {
                console.error("Error generating Excel file:", error);
            }
        }
        else if (userType === "Guest") {
            console.log("i am outside")
            if (!actualData.sessions.length > 0) {
                return
            }
            try {
                console.log("i am inside")
                const excelData = actualData?.sessions.map((search, index) => ({
                    userid: search?.userId?._id || "Guest",
                    UserName: search?.userId?.name || "Guest",
                    emailId: search?.emailid || "",
                    devicetype: search?.deviceInfo?.deviceType || "",
                    deviceid: search?.deviceInfo?.deviceId,
                    logintype: search?.loginType || "",
                    locationtype: search?.locationType || "",
                    location: search?.location || " ",
                    pincode: search?.pincode || "",
                    sessionid: search?.sessionId || "",
                    sessionTime: new Date(search?.createdAt).toLocaleDateString(),
                    Using_Duration: formatDuration(search.durationInSeconds) || "00:00:00",
                }));

                // Create workbook and worksheet
                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(excelData);

                // Add worksheet to workbook
                XLSX.utils.book_append_sheet(wb, ws, "Session Data");

                // Generate file name with session ID and current date
                const fileName = `Session_Guest_Data_${new Date().toISOString().split('T')[0]}.xlsx`;

                // Download the file
                XLSX.writeFile(wb, fileName);

            } catch (error) {
                console.error("Error generating Excel file:", error);
                // Handle error appropriately
            }
        }
        else {
            console.log("typeall",actualData)
            try {
                const excelData = actualData.map((search, index) => ({
                    userid: search?.userId?._id || "Guest",
                    UserName: search?.userId?.name || "Guest",
                    emailId: search?.emailid || "",
                    devicetype: search?.deviceInfo?.deviceType || "",
                    deviceid: search?.deviceInfo?.deviceId,
                    logintype: search?.loginType || "",
                    locationtype: search?.locationType || "",
                    location: search?.location || " ",
                    pincode: search?.pincode || "",
                    sessionid: search?.sessionId || "",
                    sessionTime: new Date(search?.createdAt).toLocaleDateString(),
                    Using_Duration: formatDuration(search.durationInSeconds) || "00:00:00",
                }));

                // Create workbook and worksheet
                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(excelData);

                // Add worksheet to workbook
                XLSX.utils.book_append_sheet(wb, ws, "Session Data");

                // Generate file name with session ID and current date
                const fileName = `SessionList_All_Data_${new Date().toISOString().split('T')[0]}.xlsx`;

                // Download the file
                XLSX.writeFile(wb, fileName);

            } catch (error) {
                console.error("Error generating Excel file:", error);
            }
        }
    };

    const clickSubmit = () => { }

    return (
        <div className="heading-input">
            <LoadingOverlay isLoading={loading || excelLoading}
                            message={excelLoading ? "Generating Excel..." : "Loading data..."} />
            <h2 className="section-heading">Session Information</h2>
            <form onSubmit={handleSubmit(clickSubmit)}>
                <table className="content-style">
                    <tbody>
                        <tr>
                            <td className="p-2 font-semibold labelName">Start Date:</td>
                            <td className="p-2">
                                <DatePicker handleDateChange={setStartDate} currentDate={startDate} />
                            </td>
                        </tr>

                        <tr>
                            <td className="p-2 font-semibold labelName">End Date:</td>
                            <td className="p-2">
                                <DatePicker handleDateChange={setLastDate} currentDate={lastDate} />
                            </td>
                        </tr>

                        <tr>
                            <td className="p-2 font-semibold labelName">User Type:</td>
                            <td className="p-2">
                                <SelectInput control={control} name="userType" required={true} option={["All","Guest", "User"]} />
                            </td>
                        </tr>

                        {userType === "User" && userInfoList.length > 0 && (
                            <tr>
                                <td className="p-2 labelName" >Phone No </td>
                                <td className="p-2">
                                    <div className="phone-selector-container" ref={dropdownRef}>
                                        <div
                                            className="phone-selector-toggle"
                                            style={{
                                                background: "white",
                                                color: "black",
                                                padding: "5px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                gap: "8px",
                                                borderRadius: "6px",
                                                border: "1px solid #ddd",
                                                cursor: "pointer",
                                                minWidth: "120px",
                                                userSelect: "none",
                                                paddingLeft: "12px",
                                            }}
                                            onClick={() => setShowPhoneNoList(!showPhoneNolist)}
                                        >
                                            <p style={{ margin: 0, color: '#6b7280' }}>{selectedPhoneNo || "Select No"}</p>
                                            <MdOutlineKeyboardArrowDown style={{
                                                transition: "transform 0.2s",
                                                transform: showPhoneNolist ? "rotate(180deg)" : "rotate(0deg)"
                                            }} />
                                        </div>
                                        {showPhoneNolist && (
                                            <ul
                                                className="phone-selector-dropdown"
                                                style={{
                                                    width: "100%",
                                                    position: "absolute",
                                                    top: "100%",
                                                    left: 0,
                                                    right: 0,
                                                    backgroundColor: "white",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "4px",
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                                    maxHeight: "200px",
                                                    overflowY: "auto",
                                                    zIndex: 1000,
                                                    marginTop: "4px",
                                                    listStyle: "none",
                                                    color: "gray",
                                                    paddingLeft: "8px"
                                                }}
                                            >
                                                {userInfoList.map((curr, i) => (
                                                    <li
                                                        key={i}
                                                        onClick={() => {
                                                            handleSelect(curr);
                                                            setShowPhoneNoList(false); // Close dropdown after selection
                                                        }}
                                                        style={{
                                                            padding: "4px 0px",
                                                            cursor: "pointer",
                                                            transition: "background-color 0.2s",
                                                            ":hover": {
                                                                backgroundColor: "#f5f5f5"
                                                            }
                                                        }}
                                                    >
                                                        <FaPhoneAlt style={{ marginRight: "10px" }} />
                                                        {curr.customerphone}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </form>
            {((userType === "User" && selectedPhoneNo) || userType === "Guest" || userType === "All") && (
                <td colSpan="2" className="p-2 text-center">
                    <button
                        className={`form-button w-48 h-10 text-white rounded transition ${(userType === "User" && selectedUserSessions.length === 0) ||
                            (userType === "Guest" && !selectedSessionNo)
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-blue-600 hover:bg-blue-700"
                            }`}
                        onClick={(e) => {

                            handleExcel();

                        }}
                    >
                        <FaDownload className="inline mr-2" />
                        Download Excel
                    </button>
                </td>
            )}
        </div>
    )
}

export default SessionInfo